module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/store_images/5@2x_5f2c9ac46264d8235d4f939305ed605d.png";